import React from "react";
import ListPriceBid from "features/Products/List/ProductBargainList";

function ProductBargain() {
  return <ListPriceBid />;
}

export default ProductBargain;
